import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalenderNextWeek: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calender-next-week"} maskId="square-filled-radius-0-stroke-1-IconCalenderNextWeek"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM20 8H4V20H20V8ZM8.5 10.7929L11.7071 14L8.5 17.2071L7.79289 16.5L10.2929 14L7.79289 11.5L8.5 10.7929ZM13 10.7929L16.2071 14L13 17.2071L12.2929 16.5L14.7929 14L12.2929 11.5L13 10.7929Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalenderNextWeek;
